import { quanLyDoiTuongViPhamRouters } from './doi-tuong-vi-pham';
import { hoSoViPhamRouters } from './ho-so-vi-pham';
import { theoDoiViPhamRouters } from './theo-doi-vi-pham';
import { baoCaoRouters } from './bao-cao';
import Loader from "Layout/Loader";
import { Suspense } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import authRouters from "./auth";
import dashboardRouters from "./dashboard";
import { userRouters } from "./user";
import { sampleModuleModuleRouters } from "./sample-module";
import { hoSoCaNhanRouters } from './ho-so-ca-nhan';
import { lichSuThanhToanRouters } from './lich-su-thanh-toan';

export const router = createBrowserRouter([
  ...authRouters,
  ...dashboardRouters,
  ...sampleModuleModuleRouters,
  ...userRouters,
  ...baoCaoRouters,
  ...theoDoiViPhamRouters,
  ...hoSoViPhamRouters,
  ...quanLyDoiTuongViPhamRouters,
  ...hoSoCaNhanRouters,
  ...lichSuThanhToanRouters
]);

export const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};
